// extracted by mini-css-extract-plugin
export default {"wrapper":"bz-z","viewport":"cz-z","container":"dz-z","slide":"ez-z"};